import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { animate, style, transition, trigger } from '@angular/animations'

/** Compteur coloré d'une carte du tableau de bord (mock-nouvelle-mission). */
export interface DashboardCardCount {
  value: number
  label: string
  /** Thème de couleur de la pastille : devis (bleu), recherche (rose), attente (orange). */
  color: 'devis' | 'rech' | 'att'
}

/**
 * Carte du tableau de bord (mock chantier G) : tuile d'icône colorée + titre,
 * puis compteurs colorés (cartes actives) ou sous-titre (cartes secondaires « muted »).
 */
@Component({
  selector: 'app-dashboard-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
  animations: [
    trigger('fadeInUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(15px)' }),
        animate('350ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ]),
  ],
})
export class DashboardCardComponent {
  @Input({ required: true }) title!: string
  @Input() icon = 'bi-grid-1x2-fill'
  /** Thème de la tuile d'icône. */
  @Input() theme: 'mission' | 'attente' | 'muted' = 'muted'
  @Input() counts: DashboardCardCount[] = []
  @Input() subtitle = ''
  @Output() cardClick = new EventEmitter<void>()

  onClick(): void {
    this.cardClick.emit()
  }
}
